"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deCountry = void 0;
var _utils = require("../utils");
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var deCountry = exports.deCountry = function deCountry(t) {
  return {
    id: 'DE',
    name: t('Germany'),
    flag: '🇩🇪',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{5}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 10115 or 80331',
    phonePrefix: '49',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Berlin',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.DE,
      checker: _companyNumber.checkers.DE,
      placeholder: 'HRB100484'
    }
  };
};